<template>
  <v-sheet v-if="item.text" color="#00567C" class="items">
    <v-container class="py-10 py-md-13 py-lg-14 mb-8 mb-md-12 item">
      <div class="text-center item-title">
        <span class="font-montserrat">ESCALA</span>
        <span class="ml-4 font-audacity">Cincinnati</span>
      </div>

      <div
        v-if="item.text"
        class="text-center mt-6 font-montserrat item-text"
        v-html="item.text"
      ></div>

      <v-row v-if="item.img" justify="center" class="mt-8 mt-md-12">
        <v-col v-if="!smAndDown" cols="12" sm="10" md="9">
          <img
            :src="files + item.img"
            class="rounded-xl d-block"
            width="100%"
          />
        </v-col>
        <v-col
          v-if="smAndDown"
          class="d-flex justify-center flex-column align-center"
          cols="12"
        >
          <img
            class="d-block w-100 rounded-img"
            :src="files + item.img_1"
            alt=""
          />
          <img
            class="d-block w-100 mt-3 rounded-img"
            :src="files + item.img_2"
            alt=""
          />
          <img
            class="d-block w-100 mt-3 rounded-img"
            :src="files + item.img_3"
            alt=""
          />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
const _config = {
  mod: "cincinnatiScale",
};

export default {
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    item() {
      return this.$rest(_config.mod).item;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100% !important;
}

.rounded-img {
  border-radius: 32px;
}
.items {
  background-image: url(/img/bg/asa.png);
  background-position: right 50px center;
  background-repeat: no-repeat;
  background-size: 90% contain;

  .item {
    &-title {
      span {
        &:first-child {
          color: white;
          font-size: 45px;
          font-weight: 700;

          @media screen and (max-width: 600px) {
            font-size: 28px;
          }
        }

        &:last-child {
          color: white;
          font-size: 78px;

          @media screen and (max-width: 600px) {
            font-size: 48px;
          }
        }
      }
    }

    &-text {
      color: white;
      font-size: 18px;
      line-height: 27px;
    }
  }
}
</style>
